// import { Workbox } from 'workbox-window';

import apiLogin from "./http/axios/axiosLogin";

export default function registerServiceWorker() {
  // Check if the serviceWorker Object exists in the navigator object ( means if browser supports SW )
  if ("serviceWorker" in navigator) {
    // const wb = new Workbox('sw.js');
    // const publicUrl = new URL(process.env.PUBLIC_URL, window.location)
    // if (publicUrl.origin !== window.location.origin) {
    // // Our service worker won't work if PUBLIC_URL is on a different origin
    // // from what our page is served on. This might happen if a CDN is used to
    // // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
    // return
    // }
    const wb = `${window.location.origin}/sw.js`;

    // wb.addEventListener("installed", (event) => {
    // window.addEventListener("installed", (event) => {
    //   console.log("event", event);
    //   /**
    //    * We have the condition — event.isUpdate because we don’t want to show
    //    * this message on the very first service worker installation,
    //    * only on the updated
    //    */
    // });
    // wb.register();

    window.addEventListener("load", function () {
      navigator.serviceWorker
        .register(wb)
        .then(
          function (registration) {
            console.log("Worker registration successful", registration.scope);
          },
          function (err) {
            console.log("Worker registration failed", err);
          }
        )
        .catch(function (err) {
          console.log(err);
        });
    });
  } else {
    console.log("Service Worker is not supported by browser.");
  }

  //update sw baru
  // window.addEventListener("fetch", function (event) {
  //   event.respondWith(
  //     caches.match(event.request).then(function (response) {
  //       if (response) {
  //         return response;
  //       } else {
  //         return fetch(event.request).then(function (res) {
  //           return caches.open(CACHE_NAME).then(function (cache) {
  //             cache.put(event.request.url, res.clone());
  //             return res;
  //           });
  //         });
  //       }
  //     })
  //   );
  // });

  // window.addEventListener("activate", function (event) {
  //   event.waitUntil(
  //     caches.keys().then(function (keyList) {
  //       return Promise.all(
  //         keyList.map(function (key) {
  //           return caches.delete(key);
  //         })
  //       );
  //     })
  //   );
  //   return window.clients.claim();
  // });
}
